import { Component, Inject, OnDestroy } from '@angular/core';
import { AuthService } from '../../../../../core/services/auth/auth.service';
import { EnfafModalComponent } from "../../../../../components/enfaf-modal/enfaf-modal.component";
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '../../../../../core/services/toast/toast.service';
import { EnfafInputComponent } from "../../../../../components/enfaf-input/enfaf-input.component";

@Component({
    selector: 'app-modal-verification-code',
    templateUrl: './modal-verification-code.component.html',
    styleUrls: ['./modal-verification-code.component.scss'],
    imports: [EnfafModalComponent, ReactiveFormsModule, EnfafInputComponent]
})
export class ModalVerificationCodeComponent implements OnDestroy {

  code = new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]);
  error: string = '';
  success: string = '';
  loading: boolean = false;
  timer: number = 0;

  private timerInterval: any;

  constructor(
    @Inject(MAT_DIALOG_DATA)public data: { email: string },
    private dialogRef: MatDialogRef<ModalVerificationCodeComponent>,
    private authService: AuthService,
    private toast: ToastService,
) {}

  ngOnDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval);
  }

  closeModal() {
    this.dialogRef.close(false);
  }

  onCodeInput() {
    this.error = '';
    this.success = '';
    let value = this.code.value || '';
    value = value.replace(/\D/g, '').slice(0, 6);
    this.code.setValue(value, { emitEvent: false });
  }

  submitCode() {
    if (this.code.invalid) return;
    this.loading = true;
    this.error = '';
    this.success = '';
    this.authService.verifyRegistration(this.data.email, this.code.value || '').subscribe({
      next: () => {
        this.toast.presentSuccessToast('¡Código verificado correctamente!');
        this.loading = false;
        this.dialogRef.close(true);
      },
      error: (err: any) => {
        this.toast.presentErrorToast(err?.error?.message || 'Error al verificar el código.');
        this.loading = false;
      }
    });
  }

  resendCode() {
    this.loading = true;
    this.error = '';
    this.success = '';
    this.authService.resendVerificationCode(this.data.email).subscribe({
      next: () => {
        this.toast.presentSuccessToast('Código reenviado. Revisa tu correo.');
        this.startTimer();
        this.loading = false;
      },
      error: (err: any) => {
        this.toast.presentErrorToast(err?.error?.message || 'Error al reenviar el código.');
        this.loading = false;
      }
    });
  }

  private startTimer() {
    this.timer = 30;
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.timerInterval = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }
}
